<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Deslocamento</h3>
      </div>
    </div>
    <Tables
      ref="tableGrid"
      :columns="columns"
      :showSearch="true"
      :showReload="false"
      :showTipFooter="false"
      v-on:Search="onShowSearch"
      v-on:Load="onLoadAll"
      v-on:Reload="onLoadAll"
    >
      <template slot="table-header-buttons">
        <a
          href="javascript:void(0);"
          v-b-tooltip.hover
          :title="'Exportar PDF'"
          @click="showConfirmationModal"
        >
          <i
            class="fas fa-file-pdf text-third"
            style="font-size: 15px"
          ></i>
        </a>
      </template>
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <template>
          <TableColumn
            :IsText="true"
            :status="1"
            :value="moment(obj.dataDeslocamento).format('DD/MM/YYYY')"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="moment(obj.dataDeslocamento).format('HH:mm:ss')"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.pessoaNome"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.gerenteNome"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="!obj.coordsInicialTempoReal ? 'SIM' : 'NÃO'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.tipoTransporte"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.kmRodadoFormatted"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.valorReembolsoString"
          />
          <TableColumn
            v-if="hasHodometro"
            :IsText="true"
            :status="1"
            :value="obj.kmRodadoPorHodometroFormatted"
          />
          <TableColumn
            v-if="hasHodometro"
            :IsText="true"
            :status="1"
            :value="obj.valorReembolsoRodadoPorHodometroString"
          />
          <td
            class="text-center"
            v-b-tooltip.hover
            title="Abrir Mapa"
          >
            <i
              @click="redirectToMaps(obj)"
              class="fas fa-map-marked-alt pointer"
            ></i>
          </td>
        </template>
      </tr>
    </Tables>
    <SidebarSearch @search="onSearch" />
    <AddConfirmation
      ref="confirmation-modal"
      :saveFunction="onExport"
      :warnText="'Deseja extrair o relatório em arquivo PDF?'"
    />
  </div>
</template>
<script>
import ReportVisitasRepository from '@/shared/http/repositories/deslocamento/report.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import SidebarSearch from '@/views/private/visitas/reports/deslocamento/search/SidebarVisitaDeslocamento.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import {CookieUtils} from '../../../../../shared/utils/cookiesUtils'

export default {
  name: 'ReportDeslocamento',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: [
        'Data',
        'Hora',
        'Cliente',
        'Gerente',
        'Localização Manual',
        'Tipo de transporte',
        'KM Estimado',
        'Valor Reembolso Estimado',
        'Mapa'
      ],
      hasHodometro: false
    }
  },
  components: {
    AddConfirmation,
    SidebarSearch },
  methods: {
    async onLoad () {
      this.onShowSearch()
      if (await this.hasHodometroVisitasRelatorio()) {
        this.columns = [
          'Data',
          'Hora',
          'Cliente',
          'Gerente',
          'Localização Manual',
          'Tipo de transporte',
          'KM Estimado',
          'Valor Reembolso Estimado',
          'KM Hodometro',
          'Valor Reembolso',
          'Mapa'
        ]
        this.hasHodometro = true
      } else {
        this.columns = [
          'Data',
          'Hora',
          'Cliente',
          'Gerente',
          'Localização Manual',
          'Tipo de transporte',
          'KM Estimado',
          'Valor Reembolso Estimado',
          'Mapa'
        ]
      }
    },
    onLoadAll () {
      loading.push()
      ReportVisitasRepository.GetAllDeslocamento(
        this.filters,
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    showConfirmationModal () {
      this.$refs['confirmation-modal'].showModal()
    },
    async onExport () {
      const cookieName = 'exportInProgress'

      if (CookieUtils.isExportInProgress(cookieName)) {
        toast.warning('A exportação já está em execução ou foi interrompida recentemente. Tente novamente mais tarde.', 'Atenção!')
        return
      }

      CookieUtils.startExport(cookieName)
      loading.push()

      await ReportVisitasRepository.GetPdf(this.filters)
        .then((response) => {
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], {
            type: 'application/pdf'
          })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioDeslocamento.pdf'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
        .finally(() => {
          CookieUtils.completeExport(cookieName)
        })

      loading.close()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    redirectToMaps (obj) {
      const latitude =
        obj.latitudeCheckOutAnterior !== null
          ? obj.latitudeCheckOutAnterior
          : obj.latitudeInicial
      const longitude =
        obj.longitudeCheckOutAnterior !== null
          ? obj.longitudeCheckOutAnterior
          : obj.longitudeInicial

      const url = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${obj.latitudeFinal},${obj.longitudeFinal}`

      if (url) {
        window.open(url, '_blank').focus()
      } else {
        toast.error('O link de acesso não está disponível', 'Erro')
      }
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/deslocamento/ReportDeslocamento.vue